export default __webpack_public_path__ + "static/media/organizacija-dogadjaja.368a254c.jpg";